import { render, staticRenderFns } from "./DeepEditTeamFromTournament.vue?vue&type=template&id=23bd7e65&scoped=true"
import script from "./DeepEditTeamFromTournament.vue?vue&type=script&lang=js"
export * from "./DeepEditTeamFromTournament.vue?vue&type=script&lang=js"
import style0 from "./DeepEditTeamFromTournament.vue?vue&type=style&index=0&id=23bd7e65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bd7e65",
  null
  
)

export default component.exports